import { Navigate } from "react-router-dom";
import axios from 'axios';
import { isAuthenticated, FLAG_SESION_VENCIDA } from '../services/api';
import { API_BASE_URL, AUDITORIA } from '../services/apiConfig';

function registrarIntruso(operacion, clave, datoAnterior, datoActualizado) {
  const userData = JSON.parse(sessionStorage.getItem("userData") || '{}');
  const token = sessionStorage.getItem("authToken");
  axios.post(API_BASE_URL + AUDITORIA, {
    operacion: operacion,
    tabla: 'Ruta Protegida',
    clave: clave,
    campo: 'perfil',
    datoanterior: datoAnterior,
    datoactualizado: datoActualizado,
    aplicacion: 'ProtectedRoute',
    usuarioid: String(userData.usuarioid || '0')
  }, {
    headers: token ? { Authorization: `Bearer ${token}` } : {}
  }).catch(() => {});
}

function ProtectedRoute({ children, perfilRequerido }) {
  if (!isAuthenticated("ProtectedRoute")) {
    // Una sesión que venció (isAuthenticated deja la marca) es un usuario real
    // al que se le terminó el tiempo, no un intento de acceso: no se audita
    // como intruso. Quien nunca tuvo sesión sí queda registrado.
    if (sessionStorage.getItem(FLAG_SESION_VENCIDA) !== '1') {
      registrarIntruso('Acceso No Autenticado', window.location.pathname, '', window.location.pathname);
    }
    return <Navigate to="/login" replace />;
  }

  if (perfilRequerido !== undefined) {
    const userData = JSON.parse(sessionStorage.getItem("userData") || '{}');
    const perfilesPermitidos = Array.isArray(perfilRequerido) ? perfilRequerido : [perfilRequerido];
    if (!perfilesPermitidos.includes(Number(userData.perfil))) {
      registrarIntruso('Acceso Denegado', window.location.pathname, String(userData.perfil), JSON.stringify(perfilesPermitidos));
      return <Navigate to="/dashboard" replace />;
    }
  }

  return children;
}

export default ProtectedRoute;
